/**
 * Entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Tag extends BaseModel {
    defaults() {
        return {
            id: null,
            tag: null,
            show_in_frontend: null,
            tag_group_id: null,
            display_order: null,
            show_banner: false,
            frontend_group: null,

            // view properties
            tag_group: null,
            for_magazin: null,
            for_event: null,
            for_address: null,
            for_schedule: null,
            is_form: null,
            is_occasion: null,
            is_additional_info: null,
            event_order: null,
            magazin_order: null,
            address_order: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            show_in_frontend: Boolean,
            tag_group_id: Number,
            display_order: Number,
            show_banner: Boolean,

            // view properties
            for_magazin: Boolean,
            for_event: Boolean,
            for_address: Boolean,
            for_schedule: Boolean,
            is_form: Boolean,
            is_occasion: Boolean,
            is_additional_info: Boolean,
        };
    }

    entityName() {
        return 'Tag';
    }
}

export class TagCollection extends BaseCollection {
    options() {
        return {
            model: Tag,
        };
    }

    entityName() {
        return 'Tag';
    }
}
